import { parse, addMinutes } from 'date-fns';

/**
 * Calculates the start and end time for a showing based on the given time, date, and duration
 * @param time - Time string in 'h:mm a' format (e.g., '8:00 am')
 * @param date - Base date to combine with the time
 * @param durationInMinutes - Duration of the showing in minutes
 * @returns Object containing startTime and endTime as Date objects
 */
export function getShowingTimeRange(
  time: string,
  date: Date,
  durationInMinutes: number,
): { startTime: Date; endTime: Date } {
  const startTime = parse(time, 'h:mm a', date);
  const endTime = addMinutes(startTime, durationInMinutes);

  return { startTime, endTime };
}
